import getClearIndicator from './ClearIndicator';

export default getClearIndicator;
